import { render, staticRenderFns } from "./FAQManagement.vue?vue&type=template&id=865816b2&scoped=true&"
import script from "./FAQManagement.vue?vue&type=script&lang=js&"
export * from "./FAQManagement.vue?vue&type=script&lang=js&"
import style0 from "./FAQManagement.vue?vue&type=style&index=0&id=865816b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865816b2",
  null
  
)

export default component.exports